import React from "react";
import classNames from "classnames";
import { useTheme } from "@mui/styles";
import { Grid, Theme } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useDispatch } from "react-redux";
import { handleEditTypes } from "./helpers";
import { IAirport } from "@vmosolutions/oc-interfaces";

export interface IAirportChip {
  itemId: string;
  code: string;
  type: "airport";
  airport: IAirport;
  // optional parameters
  /** if true, open editor for that given id and type on click. */
  edit?: boolean;
  className?: string;
  /** custom handler if not opening editor */
  onClickChip?: (airportId: string) => void;
  style?: any;
}

const AirportChipStyles = (): any => ({
  "& .icao": { width: 40 },
  "& .view_btn": { width: 20, cursor: "pointer" },
});

/**
 * AirportChip - Component used to display/action airport codes used throughout the app.
 * @param props - Component Properties [[IShortCodeChip]]
 */
export const AirportChip = (props: IAirportChip): JSX.Element => {
  const { itemId, code, type, airport, edit, className, onClickChip, style } = props;
  const theme: Theme = useTheme();
  const dispatch = useDispatch();

  const handleClickChip = (event: React.MouseEvent): void => {
    event.stopPropagation(); // important when used in the table where rows are clickable.
    if (!itemId || !onClickChip) {
      return;
    }
  };

  return (
    <Grid
      item
      className={classNames(className, !!onClickChip && itemId && "interactive", edit && "edit", type)}
      sx={AirportChipStyles()}
      onClick={handleClickChip}
      style={style}
    >
      {/* <Bookmark className="type_icon" /> */}
      <Grid container wrap="nowrap" alignItems="center">
        <Grid item className="icao">
          {code}
        </Grid>
        {!!edit && <OpenInNewIcon className="view_btn" onClick={handleEditTypes(airport, type, dispatch)} />}
      </Grid>
    </Grid>
  );
};
